import React, { useState, useEffect } from 'react';

import teamcenterService from '../../../assets/images/HomeOverview/sildes.jpg';
import Home1 from '../../../assets/images/HomeOverview/Home1.jpg';
import Home from '../../../assets/images/HomeOverview/Home.webp';
import styled from 'styled-components';


const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  perspective: 1000px;

  @media (max-width: 768px) {
    height: 400px;
  }

  @media (max-width: 576px) {
    height: 300px;
  }

  @media (max-width: 480px) {
    height: 250px;
  }
`;

const Carousel = styled.figure`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 750px;
  max-height: 500px;
  margin: auto;
  transform-style: preserve-3d;

  @media (max-width: 768px) {
    max-width: 600px;
    max-height: 400px;
  }

  @media (max-width: 576px) {
    max-width: 450px;
    max-height: 300px;
  }

  @media (max-width: 480px) {
    max-width: 350px;
    max-height: 250px;
  }
`;

const CarouselItem = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 1s cubic-bezier(.60, .16, .15, .98), opacity 1s cubic-bezier(.48, .16, .15, .98);

  &.active {
    transform: translate(-50%, -50%) translateZ(0);
    opacity: 1;
    z-index: 3;
  }

  &.left {
    transform: translate(-50%, -50%) translateZ(-150px) translateX(-100px);
    opacity: 0.5;
    z-index: 2;
  }

  &.right {
    transform: translate(-50%, -50%) translateZ(-150px) translateX(100px);
    opacity: 0.5;
    z-index: 2;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  max-height: 500px;

  @media (max-width: 768px) {
    max-height: 400px;
  }

  @media (max-width: 576px) {
    max-height: 300px;
  }

  @media (max-width: 480px) {
    max-height: 250px;
  }
`;

const images = [
  Home1,
 Home,
  teamcenterService,  
];

const HomeSlider = () => {
  const [index, setIndex] = useState(0);
  const totalItems = images.length;
  const delay = 2000;

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % totalItems);
  };

 

  useEffect(() => {
    const interval = setInterval(nextSlide, delay);
    return () => clearInterval(interval);
  }, []);

  return (
    <SliderContainer className="slider-container">
      <Carousel id="carousel--3d">
        {images.map((src, i) => (
          <CarouselItem
            key={i}
            className={`carousel-3d-item ${i === index ? 'active' : (i === (index + 1) % totalItems ? 'right' : 'left')}`}
          >
            <div className="slide-img">
              <Image className="images" src={src} alt={`Slide ${i + 1}`} />
            </div>
          </CarouselItem>
        ))}
      </Carousel>
    </SliderContainer>
  );
};

export default HomeSlider;
